import { TemplateId } from '@types';
import WUserInfoVip from '../TVip/WUserInfoVip';
import WInfoButtons from '../WInfoButtons';
import { WFeatureTogglesLegacy } from './WFeatureTogglesLegacy';

function TLegacy() {
  return (
    <>
      <WUserInfoVip templateId={TemplateId.legacy} />
      <WFeatureTogglesLegacy />
      <WInfoButtons />
    </>
  );
}

export default TLegacy;
